import AuthService from "../../services/auth-service";
import React, {PropsWithChildren} from "react";

const RenderOnAuthenticated = ({children}: PropsWithChildren<{}>) => AuthService.isLoggedIn()
    ? <>{children}</>
    : null;

export default RenderOnAuthenticated